export default string =>
  string &&
  string
    .toString()
    .toUpperCase()
    .replace(/\s+/g, '_') // Replace spaces with _
    .replace(/[^\w\-]+/g, ''); // Remove all non-word chars
